import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "./firebase";
import { ref, get, update, remove, runTransaction } from "firebase/database";
import { useReactToPrint } from "react-to-print";
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import InvoicePDF from './InvoicePDF';
import { PDFViewer as PDFViewerComponent } from '@react-pdf/renderer';
export default function OrderDetailPage() {
  const { orderId, distributorId } = useParams();
  const navigate = useNavigate();
  const componentRef = useRef();

  const [order, setOrder] = useState(null);
  const [products, setProducts] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [clientInfo, setClientInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [detteTotale, setDetteTotale] = useState(0);
  const [userType, setUserType] = useState("");
  const [vendeurInfo, setVendeurInfo] = useState(null);
  const [distributor, setDistributor] = useState({
    name: "",
    phone: ""
  });
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [showStatusDialog, setShowStatusDialog] = useState(false);
  const [showPDF, setShowPDF] = useState(false);

  const [showInvoiceDialog, setShowInvoiceDialog] = useState(false);
  const [invoiceData, setInvoiceData] = useState({
  distributorInfo: {},
  clientInfo: {},
  products: [],
  discount: 0,
  totalPrice: 0,
  finalPrice: 0,
  invoiceNumber: "",
  invoiceDate: "",
  paymentMethod: "cash",
  tvaRate: 19
});

const [showInvoiceInfoDialog, setShowInvoiceInfoDialog] = useState(false);
const [invoiceFormData, setInvoiceFormData] = useState({
  // معلومات الموزع الإضافية
  distributor: {
    name: "",
    nif: "",
    nis: "",
    rc: "",
    art: "",
    activity: "",
    rib: "",
    address: "",
    phone: "",
    email: ""
  },
  // معلومات العميل الإضافية
  client: {
    name: "",
    nif: "",
    nis: "",
    rc: "",
    art: "",
    activity: "",
    address: "",
    phone: ""
  },
  invoiceNumber: "",  
  invoiceDate: "",   
  paymentMethod: "cash",
  tvaRate: 19
});

  // جلب نوع المستخدم الحالي
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    if (user.uid) {
      const userRef = ref(db, `users/${user.uid}`);
      get(userRef).then(snapshot => {
        if (snapshot.exists()) {
          const type = snapshot.val().userType || "";
          setUserType(type.trim().toLowerCase());
        }
      });
    } else {
      setUserType("professional");
    }
  }, []);

  // جلب بيانات الموزع
  useEffect(() => {
    if (!distributorId) return;
    const userRef = ref(db, `users/${distributorId}`);
    get(userRef).then(snapshot => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setDistributor({
          name: data.tradeName || "",
        phone: data.phone || "",
        address: data.address || "",
        nif: data.nif || "",
        nis: data.nis || "",
        rc: data.rc || "",
        art: data.art || "",
        activity: data.activity || "",
        rib: data.rib || "",
        email: data.email || ""
        });
      }
    });
  }, [distributorId]);


  // مفاتيح التخزين
const STORAGE_KEYS = {
  DISTRIBUTOR_INFO: 'invoice_distributor_info',
  CLIENT_INFO: 'invoice_client_info',
  INVOICE_SETTINGS: 'invoice_settings'
};

// حفظ معلومات الموزع في localStorage
const saveDistributorToCache = (distributorData) => {
  try {
    localStorage.setItem(STORAGE_KEYS.DISTRIBUTOR_INFO, JSON.stringify(distributorData));
    console.log("Distributor info saved to cache:", distributorData);
  } catch (error) {
    console.error("Error saving distributor to cache:", error);
  }
};

// استرجاع معلومات الموزع من localStorage
const loadDistributorFromCache = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.DISTRIBUTOR_INFO);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error("Error loading distributor from cache:", error);
  }
  return null;
};

// حفظ معلومات العميل في localStorage
const saveClientToCache = (clientData) => {
  try {
    localStorage.setItem(STORAGE_KEYS.CLIENT_INFO, JSON.stringify(clientData));
    console.log("Client info saved to cache:", clientData);
  } catch (error) {
    console.error("Error saving client to cache:", error);
  }
};

// استرجاع معلومات العميل من localStorage
const loadClientFromCache = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.CLIENT_INFO);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error("Error loading client from cache:", error);
  }
  return null;
};

// حفظ إعدادات الفاتورة (طريقة الدفع، نسبة TVA)
const saveSettingsToCache = (settings) => {
  try {
    localStorage.setItem(STORAGE_KEYS.INVOICE_SETTINGS, JSON.stringify(settings));
    console.log("Settings saved to cache:", settings);
  } catch (error) {
    console.error("Error saving settings to cache:", error);
  }
};

// استرجاع الإعدادات من localStorage
const loadSettingsFromCache = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.INVOICE_SETTINGS);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error("Error loading settings from cache:", error);
  }
  return null;
};


  // دالة تحضير بيانات الفاتورة

const openInvoiceInfoDialog = () => {

  const cachedDistributor = loadDistributorFromCache();
  const cachedClient = loadClientFromCache();
  const cachedSettings = loadSettingsFromCache();

  const date = new Date();
  const timestamp = date.toISOString().slice(0,10).replace(/-/g, '');
  const randomNum = Math.floor(1000 + Math.random() * 9000);
  const defaultInvoiceNumber = `FACT-${timestamp}-${randomNum}`;
  // تعبئة البيانات الموجودة مسبقاً من الموزع والعميل
  setInvoiceFormData({
    distributor: {
      name: cachedDistributor?.name || distributor.name || "",
      nif: cachedDistributor?.nif || distributor.nif || "",
      nis: cachedDistributor?.nis || distributor.nis || "",
      rc: cachedDistributor?.rc || distributor.rc || "",
      art: cachedDistributor?.art || distributor.art || "",
      activity: cachedDistributor?.activity || distributor.activity || "",
      rib: cachedDistributor?.rib || distributor.rib || "",
      address: cachedDistributor?.address || distributor.address || "",
      phone: cachedDistributor?.phone || distributor.phone || "",
      email: cachedDistributor?.email || distributor.email || ""
    },
    client: {
      name: clientInfo.name || clientInfo.tradeName || "",
      nif: order?.clientNIF || "",
      nis: order?.clientNIS || "",
      rc: order?.clientRC || "",
      art: order?.clientART || "",
      activity: order?.clientActivity || "",
      address: clientInfo.address || "",
      phone: clientInfo.phone || ""
    },
    invoiceNumber: defaultInvoiceNumber,
    invoiceDate: new Date().toLocaleDateString('fr-FR'),
    paymentMethod: "cash",
    tvaRate: 19
  });
  setShowInvoiceInfoDialog(true);
};

// دالة إنشاء الفاتورة بعد إدخال المعلومات
const generateInvoice = () => {

  saveDistributorToCache(invoiceFormData.distributor);
  saveClientToCache(invoiceFormData.client);
  saveSettingsToCache({
    paymentMethod: invoiceFormData.paymentMethod,
    tvaRate: invoiceFormData.tvaRate
  });
  // معلومات الموزع الكاملة
  const distributorFullInfo = {
    name: invoiceFormData.distributor.name || distributor.name || "Nom du distributeur",
    address: invoiceFormData.distributor.address || distributor.address || "",
    phone: invoiceFormData.distributor.phone || distributor.phone || "",
    nif: invoiceFormData.distributor.nif || distributor.nif || "",
    nis: invoiceFormData.distributor.nis || distributor.nis || "",
    rc: invoiceFormData.distributor.rc || distributor.rc || "",
    art: invoiceFormData.distributor.art || distributor.art || "",
    activity: invoiceFormData.distributor.activity || distributor.activity || "",
    rib: invoiceFormData.distributor.rib || distributor.rib || "",
    email: invoiceFormData.distributor.email || distributor.email || ""
  };
  
  // معلومات العميل الكاملة
  const clientFullInfo = {
     name: invoiceFormData.client.name || clientInfo.name || clientInfo.tradeName || "Nom du client",
    address: invoiceFormData.client.address || clientInfo.address || "",
    phone: invoiceFormData.client.phone || clientInfo.phone || "",
    nif: invoiceFormData.client.nif || "",
    nis: invoiceFormData.client.nis || "",
    rc: invoiceFormData.client.rc || "",
    art: invoiceFormData.client.art || "",
    activity: invoiceFormData.client.activity || ""
  };

  console.log("distributorFullInfo:", distributorFullInfo); // للتحقق
  console.log("clientFullInfo:", clientFullInfo); // للتحقق
  
  // إنشاء رقم الفاتورة
  const date = new Date();
  const timestamp = date.toISOString().slice(0,10).replace(/-/g, '');
  const randomNum = Math.floor(1000 + Math.random() * 9000);
  const invoiceNumber = `FACT-${timestamp}-${randomNum}`;
  
  setInvoiceData({
    distributorInfo: distributorFullInfo,
    clientInfo: clientFullInfo,
    products: products,
    discount: discount,
    totalPrice: totalPrice,
    finalPrice: finalPrice,
    invoiceNumber: invoiceFormData.invoiceNumber,
    invoiceDate: invoiceFormData.invoiceDate, 
    paymentMethod: invoiceFormData.paymentMethod,
    tvaRate: invoiceFormData.tvaRate
  });
  
  setShowInvoiceInfoDialog(false);
  setShowInvoiceDialog(true);
};

// دالة لتحميل معلومات الموزع الكاملة (أضفها في useEffect الخاص بالموزع)
const loadFullDistributorInfo = async () => {
  if (!distributorId) return;
  const userRef = ref(db, `users/${distributorId}`);
  const snapshot = await get(userRef);
  if (snapshot.exists()) {
    const data = snapshot.val();
    setDistributor(prev => ({
      ...prev,
      address: data.address || "",
      nif: data.nif || "",
      nis: data.nis || "",
      rc: data.rc || "",
      art: data.art || "",
      activity: data.activity || "",
      rib: data.rib || "",
      email: data.email || ""
    }));
  }
};

  // حساب الديون
  const loadClientDebt = () => {
    if (!order || !distributorId) return;

    const clientId = order.clientId;
    if (!clientId) return;

    const isVendeurClient = order.nameClientAdd && order.nameClientAdd.trim() !== "";
    
    if (isVendeurClient) {
      const debtRef = ref(db, `distributors/${distributorId}/clientsAdd/${clientId}/totalDebt`);
      get(debtRef).then(snapshot => {
        if (snapshot.exists()) {
          const dette = parseFloat(snapshot.val()) || 0;
          console.log("Client debt loaded (clientsAdd):", dette);
          setDetteTotale(dette);
        } else {
          setDetteTotale(0);
        }
      }).catch(error => {
        console.error("Error loading client debt:", error);
      });
    } else {
      const debtRef = ref(db, `clients/${clientId}/debtsByDistributor/${distributorId}`);
      get(debtRef).then(snapshot => {
        if (snapshot.exists()) {
          const dette = parseFloat(snapshot.val()) || 0;
          console.log("Client debt loaded (clients):", dette);
          setDetteTotale(dette);
        } else {
          setDetteTotale(0);
        }
      }).catch(error => {
        console.error("Error loading client debt:", error);
      });
    }
  };

  useEffect(() => {
    loadClientDebt();
  }, [order, distributorId]);

  // جلب بيانات الطلب
  useEffect(() => {
    if (!orderId || !distributorId) return;
    
    const orderRef = ref(db, `distributors/${distributorId}/orders/${orderId}`);
    get(orderRef).then(snapshot => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        console.log("Order data loaded:", data);
        setOrder(data);
        
        const productsArray = [];
        if (data.products) {
          Object.entries(data.products).forEach(([key, product]) => {
            productsArray.push({
              ...product,
              productKey: key
            });
          });
        }
        
        setProducts(productsArray);
        
        setDiscount(data.discountPercent || 0);
        setTotalPrice(data.totalPrice || 0);
        setFinalPrice(data.finalPrice || data.totalPrice || 0);
        
        if (data.nameClientAdd && data.nameClientAdd.trim()) {
          setClientInfo({
            name: data.nameClientAdd,
            phone: data.telClientAdd || "-",
            address: data.adresseClientAdd || "-",
            type: "vendeur"
          });
          if (data.vendeurId) {
            loadVendeurInfo(distributorId, data.vendeurId);
          }
        } else if (data.tradeName && data.tradeName.trim()) {
          setClientInfo({
            name: data.tradeName,
            phone: data.phone || "-",
            address: data.adresse || "-",
            type: "client"
          });
        } else {
          setClientInfo({
            name: "-",
            phone: "-",
            address: "-",
            type: "unknown"
          });
        }
      }
      setLoading(false);
    });
  }, [orderId, distributorId]);

  // جلب معلومات البائع
  const loadVendeurInfo = (distributorId, vendeurId) => {
    const vendeurRef = ref(db, `distributors/${distributorId}/vendeurs/${vendeurId}`);
    get(vendeurRef).then(snapshot => {
      if (snapshot.exists()) {
        const vendeur = snapshot.val();
        setVendeurInfo({
          name: vendeur.name || "",
          lastName: vendeur.lastName || ""
        });
      }
    });
  };

  // تحديث الخصم
  const handleDiscountChange = async (e) => {
    const newDiscount = parseFloat(e.target.value) || 0;
    setDiscount(newDiscount);
    
    const discountAmount = (totalPrice * newDiscount) / 100;
    const newFinalPrice = totalPrice - discountAmount;
    setFinalPrice(newFinalPrice);

    const updates = {
      discountPercent: newDiscount,
      discountAmount: discountAmount,
      finalPrice: newFinalPrice
    };

    await update(ref(db, `distributors/${distributorId}/orders/${orderId}`), updates);
  };

  // تغيير حالة الطلب
  const changeOrderStatus = (newStatus) => {
    if (newStatus === "Terminé") {
      setShowPaymentDialog(true);
      setRemainingAmount(finalPrice);
      setShowStatusDialog(false);
      return;
    }

    if (newStatus === "Annulé") {
      const isConfirmed = window.confirm("هل أنت متأكد من رغبتك في إلغاء هذه الطلبية؟");
      if (isConfirmed) {
        cancelOrder();
      }
      return;
    }

    const updates = { status: newStatus };
    const orderRef = ref(db, `distributors/${distributorId}/orders/${orderId}`);
    
    update(orderRef, updates).then(() => {
      setOrder(prev => ({ ...prev, status: newStatus }));
      setShowStatusDialog(false);
      alert(`✅ Statut changé à ${newStatus}`);
    }).catch(error => {
      console.error("Error updating status:", error);
      alert("❌ Erreur: " + error.message);
    });
  };

  // إلغاء الطلبية
  const cancelOrder = () => {
    const updates = { status: "Annulé" };
    const orderRef = ref(db, `distributors/${distributorId}/orders/${orderId}`);
    
    update(orderRef, updates).then(() => {
      setOrder(prev => ({ ...prev, status: "Annulé" }));
      
      products.forEach(product => {
        const productRef = ref(db, `distributors/${distributorId}/products/${product.productKey}/quantity`);
        
        runTransaction(productRef, (currentQty) => {
          return (currentQty || 0) + (product.quantity || 0);
        }).catch(error => {
          console.error("Error updating stock:", error);
        });
      });

      setTimeout(() => {
        loadClientDebt();
      }, 1000);

      setShowStatusDialog(false);
      alert("✅ La commande a été annulée et le stock mis à jour");
    }).catch(error => {
      console.error("Error canceling order:", error);
      alert("❌ Erreur: " + error.message);
    });
  };

  // حساب وتحديث ديون العميل بعد الدفع
  const calculateAndUpdateTotalDebt = () => {
    if (!order?.clientId) return;

    const isVendeurClient = order.nameClientAdd && order.nameClientAdd.trim() !== "";
    
    if (isVendeurClient) {
      const ordersRef = ref(db, `distributors/${distributorId}/orders`);
      
      get(ordersRef).then(snapshot => {
        let totalDebt = 0;

        snapshot.forEach(orderSnap => {
          const orderClientId = orderSnap.child("clientId").val();
          if (orderClientId === order.clientId) {
            const status = orderSnap.child("status").val();
            if (status !== "Annulé") {
              const reste = parseFloat(orderSnap.child("resteAmount").val() || 0);
              totalDebt += reste;
            }
          }
        });

        console.log("Calculated total debt for clientAdd:", totalDebt);

        const clientRef = ref(db, `distributors/${distributorId}/clientsAdd/${order.clientId}`);
        const updates = { totalDebt: totalDebt };
        
        update(clientRef, updates).then(() => {
          setDetteTotale(totalDebt);
          console.log("Client debt updated successfully:", totalDebt);
        }).catch(error => {
          console.error("Error updating client debt:", error);
        });
      }).catch(error => {
        console.error("Error calculating debt:", error);
      });
    } else {
      const ordersRef = ref(db, `distributors/${distributorId}/orders`);
      
      get(ordersRef).then(snapshot => {
        let distributorDebt = 0;

        snapshot.forEach(orderSnap => {
          const orderClientId = orderSnap.child("clientId").val();
          if (orderClientId === order.clientId) {
            const status = orderSnap.child("status").val();
            if (status !== "Annulé") {
              const reste = parseFloat(orderSnap.child("resteAmount").val() || 0);
              distributorDebt += reste;
            }
          }
        });

        console.log("Calculated distributor debt for app client:", distributorDebt);

        const clientRef = ref(db, `clients/${order.clientId}`);
        
        get(clientRef).then(clientSnapshot => {
          const updates = {};
          let totalDebt = 0;

          if (clientSnapshot.child("debtsByDistributor").exists()) {
            clientSnapshot.child("debtsByDistributor").forEach(distDebt => {
              const distId = distDebt.key;
              if (distId !== distributorId) {
                const debt = parseFloat(distDebt.val() || 0);
                updates[`debtsByDistributor/${distId}`] = debt;
                totalDebt += debt;
              }
            });
          }

          updates[`debtsByDistributor/${distributorId}`] = distributorDebt;
          totalDebt += distributorDebt;
          updates.totalDebt = totalDebt;

          update(clientRef, updates).then(() => {
            setDetteTotale(distributorDebt);
            console.log("App client debt updated successfully:", distributorDebt);
          }).catch(error => {
            console.error("Error updating app client debt:", error);
          });
        }).catch(error => {
          console.error("Error getting client data:", error);
        });
      }).catch(error => {
        console.error("Error calculating debt:", error);
      });
    }
  };

  // معالجة الدفع
  const handlePayment = () => {
    const payed = parseFloat(paymentAmount);
    if (isNaN(payed) || payed <= 0) {
      alert("Entrez le montant payé");
      return;
    }

    const reste = finalPrice - payed;
    const finalReste = reste < 0 ? 0 : reste;

    const updates = {
      status: "Terminé",
      paidAmount: payed,
      resteAmount: finalReste
    };

    const orderRef = ref(db, `distributors/${distributorId}/orders/${orderId}`);
    
    update(orderRef, updates).then(() => {
      setOrder(prev => ({
        ...prev,
        status: "Terminé",
        paidAmount: payed,
        resteAmount: finalReste
      }));

      calculateAndUpdateTotalDebt();

      setShowPaymentDialog(false);
      setPaymentAmount("");
      alert("✅ Paiement enregistré");
    }).catch(error => {
      console.error("Error processing payment:", error);
      alert("❌ Erreur: " + error.message);
    });
  };

  // طباعة
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `Commande_${order?.orderNumber || ""}`,
    pageStyle: `
      @media print {
        .screen-only { display: none !important; }
        .print-only { display: inline !important; }
        input, button { display: none !important; }
        body { font-family: 'Inter', sans-serif; }
      }
    `,
  });
  const handleGeneratePDF = () => {
  setShowPDF(true);
};

  const statusOptions = ["Recevé", "En Préparation", "Sortir en Livraison", "Livré", "Terminé", "Annulé"];
  const currentStatusIndex = order ? statusOptions.findIndex(s => 
    s.toLowerCase() === order.status?.toLowerCase()) : -1;
  const availableStatuses = currentStatusIndex >= 0 ? 
    statusOptions.slice(currentStatusIndex) : statusOptions;

  if (loading) return <div style={styles.loading}>Loading...</div>;
  if (!order) return <div style={styles.error}>Commande introuvable.</div>;

  const canEdit = true;

  return (
    <div style={styles.container}>
      {/* شريط الأدوات */}
      <div style={styles.toolbar}>
        <button onClick={() => navigate(-1)} style={styles.backButton}>
          ← Retour
        </button>
        <h2 style={styles.title}>Détails de la commande</h2>
      </div>

      {/* بطاقة الموزع */}
      <div style={styles.distributorCard}>
        <h3 style={styles.distributorName}>{distributor.name || "Nom du distributeur"}</h3>
        <p style={styles.distributorPhone}>📞 {distributor.phone || "Téléphone"}</p>
      </div>

      {/* محتوى قابل للطباعة */}
      <div ref={componentRef} style={styles.printContent}>
        <div style={styles.printHeader}>
          <h1 style={styles.printTitle}>Bon de Livraison</h1>
        </div>

        {/* معلومات الطلب */}
        <div style={styles.orderInfo}>
          <p style={styles.orderInfoText}><strong>N° commande:</strong> #{order.orderNumber}</p>
          <p style={styles.orderInfoText}><strong>Date:</strong> {new Date(order.createdAt).toLocaleString()}</p>
          
          {/* معلومات العميل */}
          {clientInfo.type === "vendeur" ? (
            <>
              <p style={styles.orderInfoText}><strong>Client de vendeur :</strong> {clientInfo.name}</p>
              <p style={styles.orderInfoText}><strong>Téléphone :</strong> {clientInfo.phone}</p>
              <p style={styles.orderInfoText}><strong>Adresse :</strong> {clientInfo.address}</p>
              {vendeurInfo && (
                <p style={styles.orderInfoText}><strong>Vendeur:</strong> {vendeurInfo.name} {vendeurInfo.lastName}</p>
              )}
            </>
          ) : (
            <>
              <p style={styles.orderInfoText}><strong>Client de App :</strong> {clientInfo.name}</p>
              <p style={styles.orderInfoText}><strong>Téléphone :</strong> {clientInfo.phone}</p>
              <p style={styles.orderInfoText}><strong>Adresse :</strong> {clientInfo.address}</p>
            </>
          )}

          <p style={styles.orderInfoText}><strong>Statut:</strong> 
            <span style={{
              ...styles.statusBadge,
              backgroundColor: order.status?.toLowerCase() === "annulé" ? "#dc2626" : 
                             order.status?.toLowerCase() === "pending" ? "#2196F3" : "#4CAF50"
            }}>
              {order.status || "Pending"}
            </span>
          </p>
        </div>

        {/* جدول المنتجات */}
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>N°</th>
              <th style={styles.th}>Produit</th>
              <th style={styles.th}>Qte</th>
              <th style={styles.th}>Prix Unit.</th>
              <th style={styles.th}>Total</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, idx) => (
              <tr key={p.productKey || idx} style={idx % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                <td style={styles.td}>{idx + 1}</td>
                <td style={styles.td}>{p.name}</td>
                <td style={styles.td}>{p.quantity}</td>
                <td style={styles.td}>{p.price?.toFixed(2)} DA</td>
                <td style={styles.td}>{(p.price * p.quantity)?.toFixed(2)} DA</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* معلومات الدفع */}
        <div style={styles.paymentInfo}>
          <p style={styles.paymentText}><strong>Total:</strong> {totalPrice.toFixed(2)} DA</p>
          <p style={styles.paymentText}>
            <strong>Remise :</strong> 
            <input 
              type="number" 
              value={discount} 
              onChange={handleDiscountChange} 
              style={styles.discountInput} 
              className="screen-only"
            />
          </p>
          <p style={styles.paymentText}><strong>Total après remise:</strong> {finalPrice.toFixed(2)} DA</p>
          
          {order.status === "Terminé" && (
            <>
              <p style={styles.paymentText}><strong>Montant payé :</strong> {order.paidAmount?.toFixed(2) || 0} DA</p>
              <p style={styles.paymentText}><strong>Solde restant :</strong> {order.resteAmount?.toFixed(2) || 0} DA</p>
            </>
          )}

          <p style={styles.paymentText}>
            <strong style={detteTotale > 0 ? styles.debtNegative : styles.debtZero}>
              Solde impayé: {detteTotale.toFixed(2)} DA
            </strong>
          </p>
        </div>

        {/* تذييل الطباعة */}
        <div style={styles.printFooter}>
          <span>Imprimé le: {new Date().toLocaleString()}</span>
          <span>Facture générée par Komondi Application</span>
          <span>www.komondi.net</span>
        </div>
      </div>

      {/* أزرار الإجراءات */}
      <div style={styles.actionButtons}>
      <button 
  onClick={() => {
   window.open(
  `#/print-order/${distributorId}/${orderId}`,
  "_blank"
);
  }} 
  style={styles.printBtn}
>
  🖨️ Imprimer la commande
</button>

<button onClick={openInvoiceInfoDialog} style={styles.invoiceBtn}>
  📄 Générer Facture PDF
</button>

<button 
  onClick={() => {
    window.open(
  `#/print-ticket/${distributorId}/${orderId}`,
  "_blank"
);
  }} 
  style={styles.ticketBtn}
>
  🧾 Imprimer Ticket 80mm
</button>
        
        <button onClick={() => setShowStatusDialog(true)} style={styles.statusBtn}>
          🔄 Changer statut
        </button>

        <button onClick={() => navigate("/orders")} style={styles.backBtn}>
          ⬅ Retour
        </button>
      </div>

      {/* ديالوج تغيير الحالة */}
      {showStatusDialog && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <h3 style={styles.modalTitle}>Changement de statut du commande</h3>
            <div style={styles.statusList}>
              {availableStatuses.map((status) => (
                <button
                  key={status}
                  onClick={() => changeOrderStatus(status)}
                  style={{
                    ...styles.statusOption,
                    backgroundColor: status === "Annulé" ? "#ffebee" : "#f5f5f5",
                    color: status === "Annulé" ? "#dc2626" : "#000"
                  }}
                >
                  {status}
                </button>
              ))}
            </div>
            <button onClick={() => setShowStatusDialog(false)} style={styles.cancelDialogBtn}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {/* ديالوج الدفع */}
      {showPaymentDialog && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <h3 style={styles.modalTitle}>Paiement</h3>
            <p style={styles.paymentDialogText}><strong>Montant total:</strong> {finalPrice.toFixed(2)} DA</p>
            <p style={styles.paymentDialogText}><strong>Solde restant:</strong> {remainingAmount.toFixed(2)} DA</p>
            <input
              type="number"
              placeholder="Montant payé"
              value={paymentAmount}
              onChange={(e) => {
                setPaymentAmount(e.target.value);
                const payed = parseFloat(e.target.value) || 0;
                setRemainingAmount(Math.max(0, finalPrice - payed));
              }}
              style={styles.paymentInput}
              autoFocus
            />
            <div style={styles.paymentDialogButtons}>
              <button onClick={handlePayment} style={styles.validateBtn}>Valider</button>
              <button onClick={() => setShowPaymentDialog(false)} style={styles.cancelBtn}>Annuler</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal لإدخال معلومات إضافية للفاتورة */}
{showInvoiceInfoDialog && (
  <div style={styles.modalLarge}>
    <div style={styles.modalContentLarge}>
      <div style={styles.modalHeader}>
        <h3 style={styles.modalTitle}>Informations de facturation</h3>
        <button onClick={() => setShowInvoiceInfoDialog(false)} style={styles.closeModalBtn}>✕</button>
      </div>
      
      <div style={styles.invoiceFormContainer}>

         {/* ===== قسم معلومات الفاتورة الأساسية ===== */}
        <div style={styles.formSection}>
          <h4 style={styles.formSectionTitle}>📄 Informations de la facture</h4>
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="Numéro de facture"
              value={invoiceFormData.invoiceNumber}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                invoiceNumber: e.target.value
              })}
              style={styles.formInput}
            />
            <input
              type="text"
              placeholder="Date (JJ/MM/YYYY)"
              value={invoiceFormData.invoiceDate}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                invoiceDate: e.target.value
              })}
              style={styles.formInput}
            />
          </div>
        </div>

        {/* قسم الموزع */}
        <div style={styles.formSection}>
          <h4 style={styles.formSectionTitle}>📍 Informations du fournisseur</h4>
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="Nom du fournisseur"
              value={invoiceFormData.distributor.name}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, name: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>

          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="Adresse"
              value={invoiceFormData.distributor.address}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, address: e.target.value }
              })}
              style={styles.formInput}
            />
            <input
              type="text"
              placeholder="Téléphone"
              value={invoiceFormData.distributor.phone}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, phone: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="NIF"
              value={invoiceFormData.distributor.nif}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, nif: e.target.value }
              })}
              style={styles.formInput}
            />
            <input
              type="text"
              placeholder="NIS"
              value={invoiceFormData.distributor.nis}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, nis: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="RC"
              value={invoiceFormData.distributor.rc}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, rc: e.target.value }
              })}
              style={styles.formInput}
            />
            <input
              type="text"
              placeholder="NAI (ART)"
              value={invoiceFormData.distributor.art}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, art: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="Activité"
              value={invoiceFormData.distributor.activity}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, activity: e.target.value }
              })}
              style={styles.formInput}
            />
            <input
              type="text"
              placeholder="RIB"
              value={invoiceFormData.distributor.rib}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                distributor: { ...invoiceFormData.distributor, rib: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
        </div>

        {/* قسم العميل */}
        <div style={styles.formSection}>
          <h4 style={styles.formSectionTitle}>👤 Informations du client</h4>
        <div style={styles.formRow}>
            <input
              type="text"
              placeholder="Nom du client"
              value={invoiceFormData.client.name}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                client: { ...invoiceFormData.client, name: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
        
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="Adresse"
              value={invoiceFormData.client.address}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                client: { ...invoiceFormData.client, address: e.target.value }
              })}
              style={styles.formInput}
            />
            <input
              type="text"
              placeholder="Téléphone"
              value={invoiceFormData.client.phone}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                client: { ...invoiceFormData.client, phone: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="NIF"
              value={invoiceFormData.client.nif}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                client: { ...invoiceFormData.client, nif: e.target.value }
              })}
              style={styles.formInput}
            />
            <input
              type="text"
              placeholder="NIS"
              value={invoiceFormData.client.nis}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                client: { ...invoiceFormData.client, nis: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="RC"
              value={invoiceFormData.client.rc}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                client: { ...invoiceFormData.client, rc: e.target.value }
              })}
              style={styles.formInput}
            />
            <input
              type="text"
              placeholder="NAI (ART)"
              value={invoiceFormData.client.art}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                client: { ...invoiceFormData.client, art: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
          <div style={styles.formRow}>
            <input
              type="text"
              placeholder="Activité"
              value={invoiceFormData.client.activity}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                client: { ...invoiceFormData.client, activity: e.target.value }
              })}
              style={styles.formInput}
            />
          </div>
        </div>

        {/* قسم الإعدادات */}
        <div style={styles.formSection}>
          <h4 style={styles.formSectionTitle}>⚙️ Paramètres</h4>
          <div style={styles.formRow}>
            <select
              value={invoiceFormData.paymentMethod}
              onChange={(e) => setInvoiceFormData({
                ...invoiceFormData,
                paymentMethod: e.target.value
              })}
              style={styles.formSelect}
            >
              <option value="cash">Paiement en espèces (Cash)</option>
              <option value="cheque">Chèque</option>
              <option value="virement">Virement bancaire</option>
              <option value="card">Carte bancaire</option>
            </select>
            <input
  type="number"
  placeholder="TVA (%)"
  value={invoiceFormData.tvaRate}
  onChange={(e) => {
    let value = parseFloat(e.target.value);
    // السماح بالقيمة 0
    if (isNaN(value)) value = 0;
    setInvoiceFormData({
      ...invoiceFormData,
      tvaRate: value
    });
  }}
  min="0"
  max="100"
  step="0.1"
  style={styles.formInput}
/>
          </div>
        </div>
      </div>
      
      <div style={styles.pdfActions}>
        <button onClick={generateInvoice} style={styles.downloadPdfBtn}>
          Générer la facture
        </button>
        <button onClick={() => setShowInvoiceInfoDialog(false)} style={styles.closePdfBtn}>
          Annuler
        </button>
      </div>
    </div>
  </div>
)}

   {showInvoiceDialog && (
        <div style={styles.modalLarge}>
          <div style={styles.modalContentLarge}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>Aperçu de la facture</h3>
              <button onClick={() => setShowInvoiceDialog(false)} style={styles.closeModalBtn}>✕</button>
            </div>
            
            <div style={styles.pdfViewerContainer}>
              <PDFViewer style={styles.pdfViewer}>
                <InvoicePDF
                  invoiceNumber={invoiceData.invoiceNumber}
                  invoiceDate={invoiceData.invoiceDate}
                  distributor={invoiceData.distributorInfo}
                  client={invoiceData.clientInfo}
                  products={invoiceData.products}
                  discountPercent={invoiceData.discount}
                  tvaRate={invoiceData.tvaRate / 100}
                  paymentMethod={invoiceData.paymentMethod}
                  totalPrice={invoiceData.totalPrice}
                  finalPrice={invoiceData.finalPrice}
                />
              </PDFViewer>
            </div>
            
            <div style={styles.pdfActions}>
              <PDFDownloadLink
                document={
                  <InvoicePDF
                    invoiceNumber={invoiceData.invoiceNumber}
                    invoiceDate={invoiceData.invoiceDate}
                    distributor={invoiceData.distributorInfo}
                    client={invoiceData.clientInfo}
                    products={invoiceData.products}
                    discountPercent={invoiceData.discount}
                    tvaRate={invoiceData.tvaRate / 100}
                    paymentMethod={invoiceData.paymentMethod}
                    totalPrice={invoiceData.totalPrice}
                    finalPrice={invoiceData.finalPrice}
                  />
                }
                fileName={`Facture_${invoiceData.invoiceNumber}.pdf`}
                style={styles.downloadPdfBtn}
              >
                {({ loading }) => loading ? 'Préparation...' : '⬇ Télécharger PDF'}
              </PDFDownloadLink>
              <button onClick={() => setShowInvoiceDialog(false)} style={styles.closePdfBtn}>
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: 16,
    fontFamily: "'Inter', 'Roboto', sans-serif",
    maxWidth: 1200,
    margin: "0 auto",
    backgroundColor: "#f5f5f5",
    minHeight: "100vh"
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    marginBottom: 20,
    backgroundColor: "white",
    padding: "12px 20px",
    borderRadius: 8,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  backButton: {
    padding: "8px 16px",
    backgroundColor: "#6b7280",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 14
  },
  title: {
    margin: 0,
    fontSize: 20,
    color: "#1f2937"
  },
  distributorCard: {
    backgroundColor: "#2563eb",
    color: "white",
    padding: 16,
    borderRadius: 8,
    marginBottom: 20,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  distributorName: {
    margin: "0 0 4px 0",
    fontSize: 18,
    fontWeight: "bold"
  },
  distributorPhone: {
    margin: 0,
    opacity: 0.9
  },
  printContent: {
    backgroundColor: "white",
    padding: 24,
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
  },
  printHeader: {
    textAlign: "center",
    marginBottom: 20
  },
  printTitle: {
    margin: 0,
    color: "#2563eb",
    fontSize: 24,
    fontWeight: "bold"
  },
  orderInfo: {
    marginBottom: 20,
    padding: 16,
    backgroundColor: "#f8fafc",
    borderRadius: 4
  },
  orderInfoText: {
    margin: "6px 0",
    fontSize: 14
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 20
  },
  th: {
    padding: 10,
    textAlign: "left",
    border: "1px solid #09186e",
    backgroundColor: "#d6dee6",
    color: "#03010e",
    fontWeight: "bold",
    fontSize: 14
  },
  td: {
    padding: 10,
    border: "1px solid #145beb",
    fontSize: 14
  },
  rowEven: {
    backgroundColor: "#E3F2FD"
  },
  rowOdd: {
    backgroundColor: "white"
  },
  paymentInfo: {
    marginBottom: 20,
    padding: 16,
    backgroundColor: "#f8fafc",
    borderRadius: 4
  },
  paymentText: {
    margin: "6px 0",
    fontSize: 14
  },
  discountInput: {
    width: 70,
    marginLeft: 8,
    padding: 4,
    border: "1px solid #ccc",
    borderRadius: 4,
    fontSize: 14
  },
  debtNegative: {
    color: "#dc2626",
    fontWeight: "bold"
  },
  debtZero: {
    color: "#000",
    fontWeight: "bold"
  },
  printFooter: {
    marginTop: 40,
    fontSize: 10,
    display: "flex",
    justifyContent: "space-between",
    color: "#6b7280",
    borderTop: "1px dashed #ccc",
    paddingTop: 16
  },
  actionButtons: {
    display: "flex",
    gap: 10,
    marginTop: 20,
    flexWrap: "wrap",
    justifyContent: "center"
  },
  printBtn: {
    padding: "12px 24px",
    backgroundColor: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14
  },
  statusBtn: {
    padding: "12px 24px",
    backgroundColor: "#f59e0b",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14
  },
  backBtn: {
    padding: "12px 24px",
    backgroundColor: "#6b7280",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14
  },
  loading: {
    textAlign: "center",
    padding: 40,
    fontSize: 18
  },
  error: {
    textAlign: "center",
    padding: 40,
    color: "#dc2626",
    fontSize: 18
  },
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  },
  modalContent: {
    backgroundColor: "white",
    padding: 20,
    borderRadius: 8,
    width: 300,
    maxWidth: "90%"
  },
  modalTitle: {
    margin: "0 0 16px 0",
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center"
  },
  statusList: {
    marginBottom: 16,
    display: "flex",
    flexDirection: "column",
    gap: 2
  },
  statusOption: {
    width: "100%",
    padding: "12px 16px",
    border: "none",
    cursor: "pointer",
    fontSize: 14,
    textAlign: "left",
    borderBottom: "1px solid #eee"
  },
  cancelDialogBtn: {
    width: "100%",
    padding: "10px",
    backgroundColor: "#6b7280",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 14
  },
  paymentDialogText: {
    margin: "8px 0",
    fontSize: 14
  },
  paymentInput: {
    width: "100%",
    padding: 8,
    margin: "12px 0",
    border: "1px solid #ccc",
    borderRadius: 4,
    fontSize: 14
  },
  paymentDialogButtons: {
    display: "flex",
    gap: 8,
    justifyContent: "flex-end"
  },
  validateBtn: {
    padding: "8px 16px",
    backgroundColor: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 14
  },
  cancelBtn: {
    padding: "8px 16px",
    backgroundColor: "#6b7280",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 14
  },
  // أضف هذا في كائن styles
ticketBtn: {
  padding: "12px 24px",
  backgroundColor: "#10b981",
  color: "white",
  border: "none",
  borderRadius: 4,
  cursor: "pointer",
  fontWeight: 600,
  fontSize: 14
},
  statusBadge: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 4,
    color: "white",
    marginLeft: 8,
    fontSize: 12
    },
  modalLarge: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContentLarge: {
    backgroundColor: "white",
    borderRadius: 8,
    width: "90%",
    height: "90%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px",
    borderBottom: "1px solid #e5e7eb",
  },
  closeModalBtn: {
    background: "none",
    border: "none",
    fontSize: 24,
    cursor: "pointer",
    color: "#6b7280",
    padding: "0 8px",
  },
  pdfViewerContainer: {
    flex: 1,
    minHeight: 0,
  },
  pdfViewer: {
    width: "100%",
    height: "100%",
    border: "none",
  },
  pdfActions: {
    display: "flex",
    gap: 10,
    padding: "16px 20px",
    borderTop: "1px solid #e5e7eb",
    justifyContent: "flex-end",
  },
  downloadPdfBtn: {
    padding: "10px 20px",
    backgroundColor: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    textDecoration: "none",
    fontSize: 14,
  },
  closePdfBtn: {
    padding: "10px 20px",
    backgroundColor: "#6b7280",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 14,
  },
  invoiceBtn: {
    padding: "12px 24px",
    backgroundColor: "#10b981",
    color: "white",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
  },
  // أضف هذه الـ styles إلى كائن styles
invoiceFormContainer: {
  flex: 1,
  overflowY: "auto",
  padding: "20px",
},
formSection: {
  marginBottom: "24px",
  padding: "16px",
  backgroundColor: "#f8fafc",
  borderRadius: "8px",
},
formSectionTitle: {
  margin: "0 0 16px 0",
  fontSize: "16px",
  fontWeight: "bold",
  color: "#2563eb",
},
formRow: {
  display: "flex",
  gap: "12px",
  marginBottom: "12px",
},
formInput: {
  flex: 1,
  padding: "10px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  fontSize: "14px",
  outline: "none",
},
formInput: {
  flex: 1,
  padding: "10px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  fontSize: "14px",
  outline: "none",
  transition: "border-color 0.2s",
},
formSelect: {
  flex: 1,
  padding: "10px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  fontSize: "14px",
  backgroundColor: "white",
  cursor: "pointer",
},
};